import ReducerBuilder from "../../../classes/ReducerBuilder";
import initialState from "./initialState";
import {Types} from "./actions";

const reducer = new ReducerBuilder(initialState)
    .forType(Types.START_DELETE_BREAK_TAG)
    .reduce((state) => {
        state.deletingBreakTags = true;
    })
    .forType(Types.END_DELETE_BREAK_TAG)
    .reduce((state) => {
        state.toDelete = null;
        state.deletingBreakTags = false;
        state.deleteConfirmation = null;
        state.deleteConfirmationInfo = null;
    })
    .forType(Types.SELECT_TAG_FOR_DELETION)
    .reduce((state, action) => {
        state.toDelete = action.tagLabel
    })
    .forType(Types.DELETE_SELECTED_TAG)
    .reduce((state) => {
        state.deletionInProgress = true;
    })
    .forType(Types.TAG_DELETED)
    .reduce((state) => {
        state.deletionInProgress = false;
        state.toDelete = null;
        state.deleteConfirmation = null;
        state.deleteConfirmationInfo = null;
    })
    .forType(Types.REQUEST_CONFIRM_DELETED_SELECTED_TAG)
    .reduce((state, {confirmationInfo, confirmation}) => {
        state.deletionInProgress = false;
        state.deleteConfirmation = confirmation;
        state.deleteConfirmationInfo = confirmationInfo;
    })
    .forType(Types.CANCEL_SELECTED_DELETE)
    .reduce((state) => {
        state.deletionInProgress = false;
        state.toDelete = null;
        state.deleteConfirmation = null;
        state.deleteConfirmationInfo = null;
    })
    .build();

export default reducer;


// WEBPACK FOOTER //
// ./public/pages/EditBreak/DeleteBreakTagModal/reducer.js